/*
 * @Author: Lina
 * @Date: 2020-06-29 11:25:59
 * @LastEditors: Lina
 * @LastEditTime: 2020-08-24 10:47:22
 */
const host = (window.crgt && window.crgt.isProd) ? 'https://static.ccrgt.com' : 'https://t-static.ccrgt.com';

const isCRGTWXMP = {
  'netCar': {
    'path': '/packages/carhailing/pages/map/index',
    'isNativePage': true,
    'type': 'navigateTo'
  },
  'netCarOrder': {
    'path': '/packages/carhailing/pages/map/index',
    'isNativePage': true,
    'type': 'navigateTo'
  },
  'foodOrdering': {
    'path': '/packages/foodorder/pages/food-ordering/index/index',
    'type': 'navigateTo',
    'isNativePage': true
  },
  'ticket': {
    'type': 'navigateTo',
    'path': '/packages/taroTicket/pages/index/index',
    'isNativePage': true
  },
  'ticketOrder': {
    'type': 'navigateTo',
    'path': '/packages/taroTicket/pages/ticket-order-detail/index',
    'isNativePage': true
  },
  'video': null,
  'vipLounge': {
    'type': 'navigateTo',
    'path': '/pages/h5/index',
    'params': {
      'url': `${host}/app-member/#/vip-lounge?channelId=507`
    },
    'isNativePage': false
  },
  'hotel': null,
  'phoneRecharge': {
    'type': 'navigateTo',
    'path': '/pages/h5/index',
    'params': {
      'url': `${host}/phone-rechange/?_crgtwv=2`
    },
    'isNativePage': false
  },
  'youzan': {
    'type': 'navigateTo',
    'path': '/packages/other/pages/skipshop/index',
    'params': {
      '_crgtwv': '2'
    },
    'isNativePage': true
  },
  'youzanOrder': {
    'type': 'navigateTo',
    'path': '/packages/other/pages/skipshop/index',
    'isNativePage': true
  },
  'rentCar': null,
  'redHat': null,
  'shareBus': null
}

// 济铁订餐： /packages/foodorder/pages/food-ordering/index/jinan-index/index
const isJiTieWXMP = {
  'netCar': {
    'path': '/pages/goTaxi/index',
    'isNativePage': true,
    'type': 'navigateTo'
  },
  'netCarOrder': {
    'path': '/pages/goTaxi/index',
    'isNativePage': true,
    'type': 'navigateTo'
  },
  'foodOrdering': {
    'path': '/pages/food-ordering/index/index',
    'type': 'navigateTo',
    'isNativePage': true
  },
  'ticket': {
    'type': 'navigateTo',
    'path': '/packages/taroTicket/pages/index/index',
    'isNativePage': true
  },
  'ticketOrder': {
    'type': 'navigateTo',
    'path': '/packages/taroTicket/pages/ticket-order-detail/index',
    'isNativePage': true
  },
  'video': null,
  'vipLounge': {
    'type': 'navigateTo',
    'path': '/pages/h5/index',
    'params': {
      'url': `${host}/app-member/#/vip-lounge?channelId=507`
    },
    'isNativePage': false
  },
  'hotel': null,
  'phoneRecharge': {
    'type': 'navigateTo',
    'path': '/pages/h5/index',
    'params': {
      'url': `${host}/phone-rechange/?_crgtwv=2`
    },
    'isNativePage': false
  },
  'youzan': null,
  'youzanOrder': null,
  'rentCar': null,
  'redHat': null,
  'shareBus': null
}

const isCarHailingWXMP = {
  'netCar': {
    'path': '/pages/map/index',
    'isNativePage': true
  }
}
const APPID_MAP = new Map([
  ['wxf6076a6c59a2f14e', isCRGTWXMP],
  ['wxb31b88f38504e767', isCarHailingWXMP],
  ['wxc33f19505fa37f4e', isJiTieWXMP]
])
const appId = window.crgt.util.parseUrlQuery('appId')
const path = APPID_MAP.get(appId) || isCRGTWXMP;
export default path

